export default __webpack_public_path__ + "static/media/h_wdt_c_5.8996d1e1.mp3";